import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { addCampaignTypePropertyForFilter } from '../util/update-campaign-type-property-for-filter';
import { updateOdataOptionsForCriterionType } from '../util/update-criterion-property-for-filter';
import { updateOdataOptionsForLevel } from '../util/update-level-property-for-filter';

export class BaseCriterionSchemaProcessor extends BaseSchemaProcessor {
  constructor(options, filterProperties) {
    super(options);
    this.filterProperties = filterProperties;
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    // update schema to remove labels property
    updatedSchema.properties = _.omit(updatedSchema.properties, 'Labels');

    let filterList = ['Campaign/Id', 'Campaign/Name', 'Campaign/Status', 'AdGroup/Id', 'AdGroup/Name', 'AdGroup/Status', 'CriterionBid', 'LevelOfDetails'];
    if (this.Permissions.IsExperimentsEnabled) {
      filterList = filterList.concat(['Campaign/IsExperiment']);
    }
    filterList = filterList.concat(this.filterProperties);

    const biPattern = /^(PoP)?PerformanceMetrics/;
    updatedSchema.properties = _.pick(
      entitySchema.properties,
      prop => _.contains(filterList, prop.property) || biPattern.test(prop.property)
    );

    const campaignStatusProperty = updatedSchema.properties.CampaignStatus;
    if (campaignStatusProperty) {
      campaignStatusProperty.filterable = false;
    }

    const adgroupStatusProperty = updatedSchema.properties.AdGroupStatus;
    if (adgroupStatusProperty) {
      adgroupStatusProperty.filterable = false;
    }

    updatedSchema.properties = _.mapObject(updatedSchema.properties, prop => ({
      ...prop,
      title: prop.title || this.i18n.getString(`FilterLocalization_DataAttribute_${_.result(prop.alias, 'legacy') || prop.originalProperty}`),
    }));

    if (this.isForVNext) {
      const campaignTypeNotSupported = ["Enum.CampaignType'LinkedIn'"];
      addCampaignTypePropertyForFilter({
        entitySchema: updatedSchema, permissions: this.Permissions, campaignTypeNotSupported,
      });
    }

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);
    updateOdataOptionsForCriterionType(odataOptions);
    updateOdataOptionsForLevel(odataOptions);

    return odataOptions;
  }
}
